// extracted by mini-css-extract-plugin
export var actionText = "_jo-4";
export var container = "_jo-0";
export var leftSection = "_jo-1";
export var rightSection = "_jo-2";
export var settingsButton = "_jo-6";
export var settingsIcon = "_jo-7";
export var shortcut = "_jo-5";
export var shortcutGroup = "_jo-3";